module.exports = "/packs/images/homepage/facilities/library~578e445b0d84305ce2fb7847954d3df8.jpg";